import request from "../../../utils/request";

export function getTodo() {
    return request.request({
        method: "get",
        url: "/index/todo"
    })
}

export function getMonthData() {
    return request.request({
        method:"get",
        url:'/index/monthData'
    })
}
